// [PATCH izdani-doctype-fe v2]  ·  02.08.2026
// Zrcalo backend/app/core/doc_smer.py. Ce se spremeni eden, se mora drugi.
//
// ZAKAJ: do uvedbe izdanih avansov in dobropisov je vmesnik smer ugotavljal
// z doc_type === 'izdani_racun' na 29 mestih. Z dvema novima IZDANIMA
// vrstama bi vsako tako mesto novi vrsti obravnavalo kot PREJETI dokument:
// dobavitelj namesto kupca, KPR namesto KIR, interna stevilka s serijo,
// gumb za razrez PDF, tiho premikanje datuma ob davcni blokadi.

export const PREJETI_TIPI = ['prejeti_racun', 'credit_note', 'avans', 'storno_avansa'];
export const IZDANI_TIPI = ['izdani_racun', 'izdani_avans', 'izdani_dobropis'];

export type TipDok = { v: string; label: string };

// Vrste, med katerimi je dovoljena ROCNA menjava (brez storno_avansa).
export const TIPI_DOK_PREJETI: TipDok[] = [
  { v: 'prejeti_racun', label: 'Prejeti račun' },
  { v: 'credit_note', label: 'Dobropis' },
  { v: 'avans', label: 'Avans' },
];
export const TIPI_DOK_IZDANI: TipDok[] = [
  { v: 'izdani_racun', label: 'Izdani račun' },
  { v: 'izdani_avans', label: 'Avans' },
  { v: 'izdani_dobropis', label: 'Dobropis' },
];
export const TIPI_DOK_VSI: TipDok[] = [...TIPI_DOK_PREJETI, ...TIPI_DOK_IZDANI];

export function jeIzdaniTip(t?: string | null): boolean {
  return IZDANI_TIPI.indexOf(String(t || '')) >= 0;
}

export function smerTipa(t?: string | null): 'izdani' | 'prejeti' {
  // Neznan tip -> 'prejeti': enako, kot se je obnasal prejsnji izraz.
  return jeIzdaniTip(t) ? 'izdani' : 'prejeti';
}

export function tipiZaMenjavo(t?: string | null): TipDok[] {
  return jeIzdaniTip(t) ? TIPI_DOK_IZDANI : TIPI_DOK_PREJETI;
}

export function oznakaTipa(t?: string | null): string {
  const najden = TIPI_DOK_VSI.find(x => x.v === String(t || ''));
  return najden ? najden.label : String(t || '');
}

/* [PATCH interne-predpone v1] Predpone internih stevilk (zrcalo backend
   app/core/doc_smer.py: leto_iz_serije / predpona_iz_serije).
   Serija nosi predpono in letnico: '2026' | 'IR2026' | 'A2026' | 'AIR2026'. */
export const letoIzSerije = (s: any): string => { const m = String(s ?? '').match(/(\d{4})$/); return m ? m[1] : ''; };
export const predponaIzSerije = (s: any): string => String(s ?? '').replace(/(IR)?\d{4}$/, '');
export const internaPrikaz = (d: any): string => {
  /* [PATCH izdani-interna-originalna v1] interna oznaka (predpona + st. racuna)
     ima prednost; nastavi se samo pri izdanih z nastavitvijo "originalna". */
  if (d?.interna_oznaka) return String(d.interna_oznaka);
  if (d?.interno_st === null || d?.interno_st === undefined || d?.interno_st === '') return '—';
  const pred = predponaIzSerije(d.interno_st_serija);
  if (jeIzdaniTip(d.doc_type)) return `${pred}${d.interno_st}`;          // A1
  return `${pred}${d.interno_st}/${letoIzSerije(d.interno_st_serija)}`;   // A1/2026
};

/** Kratka oznaka za znacko v seznamu (samo vrste, ki niso navadni racun). */
export function oznakaKratka(t?: string | null): string {
  const s = String(t || '');
  if (s === 'credit_note' || s === 'izdani_dobropis') return 'Dobropis';
  if (s === 'avans' || s === 'izdani_avans') return 'Avans';
  if (s === 'storno_avansa') return 'Storno';
  return s;
}

/** Tailwind razredi znacke; dobropisi rozno, avansi indigo, ostalo sivo. */
export function barvaTipa(t?: string | null): string {
  const s = String(t || '');
  if (s === 'credit_note' || s === 'izdani_dobropis')
    return 'bg-rose-100 text-rose-700 dark:bg-rose-900 dark:text-rose-300';
  if (s === 'avans' || s === 'izdani_avans')
    return 'bg-indigo-100 text-indigo-700 dark:bg-indigo-900 dark:text-indigo-300';
  return 'bg-gray-200 text-gray-600 dark:bg-gray-700 dark:text-gray-300';
}
